export const SegmentConstants = {
  GET_SEGMENT_REQUEST: 'segment/GET_SEGMENT_REQUEST',
  GET_SEGMENT_SUCCESS: 'segment/GET_SEGMENT_SUCCESS',
  GET_SEGMENT_ERROR: 'segment/GET_SEGMENT_ERROR',
  GET_CATEGORY_REQUEST: 'segment/GET_CATEGORY_REQUEST',
  GET_CATEGORY_SUCCESS: 'segment/GET_CATEGORY_SUCCESS',
  GET_CATEGORY_ERROR: 'segment/GET_CATEGORY_ERROR',
  CREATE_SEGMENT_REQUEST: 'segment/CREATE_SEGMENT_REQUEST',
  CREATE_SEGMENT_SUCCESS: 'segment/CREATE_SEGMENT_SUCCESS',
  CREATE_SEGMENT_ERROR: 'segment/CREATE_SEGMENT_ERROR',
  GET_USER_COUNT_REQUEST: 'segment/GET_USER_COUNT_REQUEST',
  GET_USER_COUNT_ERROR: 'segment/GET_USER_COUNT_ERROR',
  GET_USER_COUNT_SUCESS: 'segment/GET_USER_COUNT_SUCESS',
  APPLIED_FILTERS: 'segment/APPLIED_FILTERS',
  RESET_APPLIED_FILTERS: 'segment/RESET_APPLIED_FILTERS',
  GET_SEGMENT_LIST_REQUEST: 'segment/GET_SEGMENT_LIST_REQUEST',
  GET_SEGMENT_LIST_SUCCESS: 'segment/GET_SEGMENT_LIST_SUCCESS',
  GET_SEGMENT_LIST_ERROR: 'segment/GET_SEGMENT_LIST_ERROR',

  GET_SEGMENT_DETAILS_REQUEST: 'segment/GET_SEGMENT_DETAILS_REQUEST',
  GET_SEGMENT_DETAILS_SUCCESS: 'segment/GET_SEGMENT_DETAILS_SUCCESS',
  GET_SEGMENT_DETAILS_ERROR: 'segment/GET_SEGMENT_DETAILS_ERROR',

  GET_SEARCH_SEGMENT_REQUEST: 'segment/GET_SEARCH_SEGMENT_REQUEST',
  GET_SEARCH_SEGMENT_SUCCESS: 'segment/GET_SEARCH_SEGMENT_SUCCESS',
  GET_SEARCH_SEGMENT_ERROR: 'segment/GET_SEARCH_SEGMENT_ERROR',

  DELETE_SEGMENT_SUCCESS: 'segment/DELETE_SEGMENT_SUCCESS'
};
